import React from 'react';
import { cloudinaryRes, imageURL, thumbParams } from '../apis/cloudinary';
import { 
    Container, 
    Grid, 
    Header, 
    Image
 } from 'semantic-ui-react';

class HomePage extends React.Component {

    state = {
        patioUrl: '',
        wallUrlL: '',
        walkwayUrl: ''
    };

    getList = async (category) => {
        const response =  await cloudinaryRes.get(`/list/${category}.json`);
        return response.data;
    }

    componentDidMount() {
        this.getList('Patios').then( ({resources}) => {
            const [ picture ] = resources;
            this.setState( { patioUrl: `${imageURL}/${thumbParams}/${picture.public_id}`} );
        });
        this.getList('Walls').then( ({resources}) => {
            const [ picture ] = resources;
            this.setState( { wallUrl: `${imageURL}/${thumbParams}/${picture.public_id}`} );
        });
        this.getList('Walkways').then( ({resources}) => {
            const [ picture ] = resources;
            this.setState( { walkwayUrl: `${imageURL}/${thumbParams}/${picture.public_id}`} );
        });
    }
    render() {
        const { patioUrl, wallUrl, walkwayUrl } = this.state;
        return (
            <Container fluid>
                <Grid columns={3} stackable textAlign='center'>

                <Grid.Row verticalAlign='middle'>
                    <Grid.Column>
                    <Header>Patios</Header>
                        <Image 
                            src={patioUrl} 
                            href="http://www.stoneways.com/?page_id=8"
                            target="_top" 
                            circular 
                            centered
                        />
                    </Grid.Column>
                    <Grid.Column>
                    <Header>Walkways</Header>
                        <Image 
                            src={walkwayUrl} 
                            href="http://www.stoneways.com/?page_id=10" 
                            target="_top" 
                            circular 
                            centered
                        />
                    </Grid.Column>
                    <Grid.Column>
                        <Header>Walls</Header>
                        <Image 
                            src={wallUrl} 
                            href="http://www.stoneways.com/?page_id=15" 
                            target="_top" 
                            circular 
                            centered
                        />
                    </Grid.Column>
                </Grid.Row>
                </Grid>
            </Container>
        );
    }
}

export default HomePage;